// extracted by mini-css-extract-plugin
module.exports = {"chargeTypeIcon":"chargeTypesView_chargeTypeIcon__3wqVz","chargePrice":"chargeTypesView_chargePrice__1fFg2"};